var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "q-edit-content" },
    [
      !_vm.value.ext.edit
        ? _c("com-input", {
            attrs: {
              disabled: _vm.isPreview || _vm.isReplay,
              type: _vm.value.style,
              "max-length": _vm.getLimitLength,
              "show-length": _vm.isReplay
                ? false
                : _vm.value.detail.format !== "integer",
            },
            on: { focus: _vm.focus },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.value.ext.edit && _vm.errorTip
        ? _c("div", { staticClass: "error-msg" }, [
            _vm._v("\n    " + _vm._s(_vm.errorTip) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }